import Service from "./Service"


export default class FeedbackService extends Service {
    constructor() {
        super()
        this.serviceUrl = `https://api.travelski.com/feedback`
        this.mandatoryFields = {
            "getRateByLihe": ['liheId', "locale"],
        }
    }


    async getRateByLihe(requestData) {
        this.checkMandatoryFields(requestData, "getRateByLihe")
        const {
            liheId,
            averageRatingMin,
            averageRatingMax,
            locale,
            start,
            size,
            sortFields,
            sortDirs,
        } = requestData
        const headers = {
            "accept-language": locale.replace("_", "-")
        }
        const params = {
            averageRatingMin,
            averageRatingMax,
            start,
            size,
            sortFields,
            sortDirs,
        }
        const url = `${this.serviceUrl}/rate/byLihe/${liheId}`
        const {
            data
        } = await this.axios.get(url, {
            params,
            headers
        })
        return data
    }


}